<template>
<div class="main whiteList">
    <header class="">
        <div class="tit-con"> <img class="back-icon" @click="$router.go(-1)" src="@/assets/imgs/back.png" />白名单客户管理</div>
        <el-form ref="formSearch" :inline="true" label-width="100px">
            <el-form-item label="手机号" label-width="auto;">
                <el-input v-model="mobile" />
            </el-form-item>

            <el-form-item label="导入时间" label-width="auto;">
                <el-date-picker value-format="yyyy-MM-dd" v-model="dealTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="领取" label-width="auto;">
                <el-select v-model="acceivingStatus">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已领取" value="1"></el-option>
                    <el-option label="未领取" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="核销" label-width="auto;">
                <el-select v-model="writeOffStatus">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已核销" value="3"></el-option>
                    <el-option label="未核销" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
            </el-form-item>
            <el-form-item>
                <a class="imitate-el_btn" :href="exportExcel" download="1">导出</a>
            </el-form-item>
            <el-form-item>
                <a class="imitate-el_btn" @click="showImport()">单个导入</a>
            </el-form-item>
            <el-form-item v-loading="uLoading">
                <el-upload ref="uploadFile" class="avatar-uploader" :action="fileUpload" :on-change="fileChange" :show-file-list="false" :on-success="createHandleAvatarSuccess('file')" :auto-upload="false" :on-progress="onProgress" :on-error="onError" :before-upload="beforeAvatarUpload">
                    <div class="pic-box">

                        <el-button type="primary">导入名单</el-button>
                        <div v-if="fileUrl">
                            {{fileUrl}}
                        </div>
                    </div>
                </el-upload>
            </el-form-item>
        </el-form>
    </header>

    <header class="">
        <div class="info-message">
            <span style="margin-right: 20px">登录用户: {{userInfo.anotherName}}</span>
            <span>类型: {{accountGiveType}}</span>
            <template v-if="userInfo.allotType == 0">
                <span>账户余额: {{amountData.accountBalance}}元</span>
                <span>派券金额: {{amountData.countGrantBalance}}元</span>
            </template>
        </div>
        <!-- <el-button :disabled="multipleSelection.length === 0" type="primary" @click="handleDelSome">删除名单</el-button> -->
    </header>
    <el-table v-loading="tLoading" row-key="id" ref="multipleTable" :data="tableData" border stripe tooltip-effect="dark" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
        <!-- <el-table-column disabled reserve-selection type="selection" width="55" :selectable="selectable">
        </el-table-column> -->
        <el-table-column prop="mobile" label="手机号">
        </el-table-column>
        <el-table-column label="分配类型">
            <template slot-scope="scope">
                {{ scope.row.allotType == 0 ? '金额赠送':'闪付优惠券' }}
            </template>
        </el-table-column>
        <el-table-column prop="presented" label="赠送金额">
            <template slot-scope="scope">
                {{ scope.row.allotType == 0 ? scope.row.presented : '-'}}
            </template>
        </el-table-column>
        <el-table-column label="分配方式">
            <template slot-scope="scope">
                {{
                   scope.row.allotType == 0 ? (scope.row.distribution == 0 ? '整额': '等额'): '-'
                }}
            </template>
        </el-table-column>
        <el-table-column label="优惠券名称">
            <template slot-scope="scope">
                {{
                    scope.row.couponName
                }}
            </template>
        </el-table-column>
        <!-- <el-table-column prop="cardNumTail" label="卡尾号" >
        </el-table-column> -->
        <el-table-column label="导入时间">
            <template slot-scope="scope">{{
                    scope.row.importTime
                }}</template>
        </el-table-column>
        <!-- <el-table-column prop="operator" label="导入人" >
        </el-table-column> -->
        <el-table-column label="领取状态" width="100px">
            <template slot-scope="scope">{{
                     scope.row.acceivingStatus === 1 ? '已领取': '未领取'
                }}</template>
        </el-table-column>
        <el-table-column label="核销状态" width="100px">
            <template slot-scope="scope">{{
                 scope.row.writeOffStatus === 3 ? '已核销': '未核销'
                }}</template>
        </el-table-column>

        <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
                <div style="width:40px;height:40px; float:left;" v-if="scope.row.writeOffStatus !== 3">
                    <el-popover trigger="click" placement="top" width="160" :ref="`popover-${scope.row.id}`">
                        <p>确定删除吗？</p>
                        <div style="text-align: right; margin: 0; float:left;padding-top:24px;">
                            <el-button size="mini" type="text" @click="pClose(scope.row.id)">取消</el-button>
                            <el-button type="primary" size="mini" @click="fetchDel(scope.row.id)" :loading="loadbtn">确定</el-button>
                        </div>
                        <div slot="reference" class="name-wrapper">
                            <span class="do">删除</span>
                        </div>
                    </el-popover>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <!-- <div class="select-count">
        当前已选中{{multipleSelection.length || 0}}条记录
    </div> -->
    <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalPage">
        </el-pagination>
    </div>

    <!-- 弹出导入 -->
    <el-dialog title="单个导入" :visible.sync="dialogFormVisible" width="1000px">
        <div class="body orderAudit">
            <section>
                <div class="info-message">
                    <span style="margin-right: 20px">登录用户: {{userInfo.anotherName}}</span>
                    <span>类型: {{accountGiveType}}</span>
                    <template v-if="userInfo.allotType == 0">
                        <span>账户余额: {{amountData.accountBalance}}元</span>
                        <span>派券金额: {{amountData.countGrantBalance}}元</span>
                    </template>
                </div>
                <div class="formbox">
                    <el-form ref="ruleForm" label-width="140px" class="demo-ruleForm">
                        <el-form-item>
                            <div class="orderAudit-row">
                                <!-- 等额 -->
                                <table class="tg" v-if="userInfo.allotType == 0">
                                    <tr>
                                        <td class="tg-cly1" style="width:15%;">序号</td>
                                        <td class="tg-cly1" style="width:25%;">客户手机号</td>
                                        <td class="tg-cly1" style="width:20%;">优惠券金额</td>
                                        <td class="tg-cly1" style="width:20%;">分配方式</td>
                                        <td class="tg-cly1" style="width:20%;">操作</td>
                                    </tr>
                                    <tr v-for="(item, index) in receiveList" :key="index + 'x'">
                                        <td class="tg-cly3">
                                            <el-input disabled class="input" :value="index + 1"></el-input>
                                        </td>
                                        <td class="tg-cly3">
                                            <el-input class="input" :maxlength="11" v-model="item.mobile"></el-input>
                                        </td>
                                        <td class="tg-cly3">
                                            <el-input class="input" v-model="item.money"></el-input>
                                        </td>
                                        <td class="tg-cly3">
                                            <!-- <el-input class="input" v-model="item.type"></el-input> -->
                                            <el-select v-model="item.type" placeholder="分配方式">
                                                <el-option v-for="(tank, i) in typeData" :key="i" :label="tank.name" :value="tank.id"></el-option>
                                            </el-select>
                                        </td>
                                        <td>
                                            <div class="orderAudit-row-del ys-a-pot" @click="clickDelWork(index)">删除</div>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="tg-cly3" style="text-align:left" colspan="8">
                                            <div class="do ys-a-pot" @click="clickAddWork">添加</div>
                                        </td>
                                    </tr> -->
                                    <tr>
                                        <td class="tg-cly3" style="text-align:left" colspan="8">
                                            <el-button type="primary" class="ys-a-pot" :disabled="loadingImport" @click="handleSaveImport">确认导入</el-button>
                                        </td>
                                    </tr>
                                </table>
                                <!-- 闪付优惠券 -->
                                <table v-else class="tg">
                                    <tr>
                                        <td class="tg-cly1" style="width:15%;">序号</td>
                                        <td class="tg-cly1" style="width:25%;">客户手机号</td>
                                        <td class="tg-cly1" style="width:20%;">操作</td>
                                    </tr>
                                    <tr v-for="(item, index) in receiveList" :key="index + 'x'">
                                        <td class="tg-cly3">
                                            <el-input disabled class="input" :value="index + 1"></el-input>
                                        </td>
                                        <td class="tg-cly3">
                                            <el-input class="input" :maxlength="11" v-model="item.mobile"></el-input>
                                        </td>
                                        <td>
                                            <div class="orderAudit-row-del ys-a-pot" @click="clickDelWork(index)">删除</div>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="tg-cly3" style="text-align:left" colspan="8">
                                            <div class="do ys-a-pot" @click="clickAddWork">添加</div>
                                        </td>
                                    </tr> -->
                                    <tr>
                                        <td class="tg-cly3" style="text-align:left" colspan="8">
                                            <el-button type="primary" class="ys-a-pot" :disabled="loadingImport" @click="handleSaveImport">确认导入</el-button>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </el-form-item>
                    </el-form>
                </div>
            </section>
        </div>
    </el-dialog>

    <!-- 弹出导入内容 多个 -->
    <el-dialog title="导入内容" :visible.sync="dialogFormMoreVisible" width="1000px">
        <div class="body orderAudit">
            <section>
                <div class="info-message">
                    <span style="margin-right: 20px">登录用户: {{userInfo.anotherName}}</span>
                    <span>类型: {{accountGiveType}}</span>
                    <template v-if="userInfo.allotType == 0">
                        <span>账户余额: {{amountData.accountBalance}}元</span>
                        <span>本次导入金额: {{receiveTotal}}元</span>
                    </template>
                </div>
                <div class="formbox">
                    <el-form ref="ruleForm" label-width="140px" class="demo-ruleForm">
                        <el-form-item>
                            <div class="orderAudit-row">
                                <!-- 等额 -->
                                <table class="tg" v-if="userInfo.allotType == 0">
                                    <tr>
                                        <td class="tg-cly1" style="width:15%;">序号</td>
                                        <td class="tg-cly1" style="width:25%;">客户手机号</td>
                                        <td class="tg-cly1" style="width:20%;">优惠券金额</td>
                                        <td class="tg-cly1" style="width:20%;">分配方式</td>
                                    </tr>
                                    <tr v-for="(item, index) in receiveMoreList" :key="index + 'x'">
                                        <td class="tg-cly3">
                                            {{index + 1}}
                                        </td>
                                        <td class="tg-cly3">
                                            {{item.mobile}}
                                        </td>
                                        <td class="tg-cly3">
                                            {{item.money}}
                                        </td>
                                        <td class="tg-cly3">
                                            {{item.type}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="tg-cly3" style="text-align:left" colspan="8">
                                            <el-button type="primary" class="ys-a-pot" @click="handleSaveImportMore">确认导入</el-button>
                                        </td>
                                    </tr>
                                </table>
                                <table v-else class="tg">
                                    <tr>
                                        <td class="tg-cly1" style="width:15%;">序号</td>
                                        <td class="tg-cly1" style="width:25%;">客户手机号</td>
                                    </tr>
                                    <tr v-for="(item, index) in receiveMoreList" :key="index + 'x'">
                                        <td class="tg-cly3">
                                            {{index + 1}}
                                        </td>
                                        <td class="tg-cly3">
                                            {{item.mobile}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="tg-cly3" style="text-align:left" colspan="8">
                                            <el-button type="primary" class="ys-a-pot" @click="handleSaveImportMore">确认导入</el-button>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </el-form-item>
                    </el-form>
                </div>
            </section>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {
    rap,
    fetch
} from "@/utils/common.js";

let url = {
    // fileUpload: "/fep/file/adds",
    profile: "/fep/pc/marketingUserAdmin/getUserMessage",
    exportExcel: "/fep/pc/marketingUserAdmin/exportExcel",
    list: "/fep/pc/marketingUserAdmin/customerList",
    importExcel: "/fep/pc/marketingUserAdmin/importExcel",
    del: "/fep/pc/marketingUserAdmin/delCustomer",
    addImport: "/fep/pc/marketingUserAdmin/importOne",
    amount: "/fep/pc/marketingUserAdmin/clearMoney",
    getType: "/fep/pc/marketingUserAdmin/access"
};

let defaulAddItem = {
    mobile: '',
    state: 1,
    money: '',
    type: ''
}
export default {
    components: {},
    props: [],
    data() {
        return {
            fileUpload: url.importExcel,
            userInfo: {},
            loadingImport: false,
            loadbtn: false,
            fileUrl: undefined,
            uLoading: false,
            tLoading: false,
            total: 0,
            pageNo: 1,
            pageSize: 10,
            totalPage: 0,
            tableData: [],
            multipleSelection: [],
            amountData: {},
            dealTime: "",
            mobile: undefined,
            writeOffStatus: undefined,
            acceivingStatus: undefined,
            cycle: undefined,
            dialogFormVisible: false,
            dialogFormMoreVisible: false,
            distribution: 2,
            uploadDone: false,
            receiveList: [{
                ...defaulAddItem
            }],
            receiveMoreList: [],
            receiveTotal: 0,
            typeData: [{
                id: '1',
                name: '等额'
            }, {
                id: '0',
                name: '整额'
            }],
        };
    },
    computed: {
        accountGiveType() {
            if (this.userInfo) {
                return this.userInfo.allotType == 0 ? '金额赠送' : '闪付优惠券'
            }
            return ''
        },
        exportExcel() {
            let data = {
                mobile: this.mobile,
                writeOffStatus: this.writeOffStatus,
                acceivingStatus: this.acceivingStatus
            }
            if (this.dealTime) {
                data = {
                    ...data,
                    beginDate: this.dealTime[0],
                    endDate: this.dealTime[1]
                }
            }

            let tmpArr = Object.keys(data)
            let tmpStr = '?'
            tmpArr.forEach(item => {
                let str
                str = '&' + item + '=' + data[item]
                if (data[item]) {
                    tmpStr += str
                }
            })
            return url.exportExcel + tmpStr
        }
    },
    watch: {},
    created() {},
    mounted() {
        // fetch(url.profile).then((res) => {});
        fetch(url.profile).then((res) => {
            this.userInfo = res.data
        });

        this.getList();
        this.getAmount()
    },
    methods: {

        getAmount() {
            fetch(url.amount).then((res) => {
                this.amountData = res.data
            });
            fetch(url.getType).then((res) => {
                // this.typeOption = res.data
                let distribution = res.data.distribution
                this.distribution = distribution
                if (distribution == 0) {
                    // 整额
                    this.typeData = [{
                        id: '0',
                        name: '整额'
                    }]
                } else if (distribution == 1) {
                    // 等额
                    this.typeData = [{
                        id: '1',
                        name: '等额'
                    }]
                } else if (distribution == 2) {
                    // 都有
                    this.typeData = [{
                        id: '1',
                        name: '等额'
                    }, {
                        id: '0',
                        name: '整额'
                    }]
                }

                // 单个导入给分配方式默认值
                let item = defaulAddItem
                item.type = this.typeData[0].id
                this.receiveList = [
                    item
                ]
            });
        },
        selectable(row, index) {
            return row.acceivingStatus !== 1;
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            if (row.cycle === 2) {
                return "d-sel";
            }
            return "";
        },
        showImport() {
            this.receiveList = [
                    {...defaulAddItem}
                ]
            this.dialogFormVisible = true
        },
        clickAddWork() {
            this.receiveList.push({
                ...defaulAddItem
            })
        },
        // 删除明细
        clickDelWork(index) {
            this.receiveList.splice(index, 1)
        },
        // 保存导入的
        handleSaveImport() {
            const list = this.receiveList
            var expMoney = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
            let check = true
            let element
            for (const i in list) {
                element = list[i]
                if (!element.mobile || element.mobile.length != 11) {
                    this.$message.error('请输入正确的11位手机号码');
                    check = false
                    return
                }
                // if (!expMoney.test(element.money)) {
                //     this.$message.error('请输入正确的金额');
                //     check = false
                //     return
                // }
                // if (!element.type) {
                //     this.$message.error('请选择分配方式');
                //     check = false
                //     return
                // }
            }
            this.loadingImport = true
            const self = this
            // debugger
            // 存入
            let data = {
                distribution: element.type,
                mobile: element.mobile,
                presented: element.money
            }
            fetch(url.addImport, data).then(
                (res) => {
                    // debugger
                    this.loadingImport = false
                    if (res.status === 200) {
                        // 刷新
                        self.$message.success('导入成功');
                        this.dialogFormVisible = false
                        this.receiveList = [{
                            ...defaulAddItem
                        }]

                        setTimeout(() => {
                            this.getList()
                            this.getAmount()
                        }, 300);
                    }

                },
                (res) => {
                    // debugger
                    this.loadingImport = false
                    self.$message.error(res.message);
                }
            ).catch(err => {
                this.loadingImport = true
                // debugger
                self.$message.error(err.message);
            });
        },
        handleImportExcel() {
            const {
                fileUrl
            } = this
            if (!fileUrl || fileUrl == '') {
                return
            }
            let data = {
                fileRoot: fileUrl
            }
            fetch(url.importExcel, data).then(
                (res) => {
                    if (res.status === 200) {
                        // 刷新
                        this.getList()
                    }
                },
                (res) => {
                    this.$message.error(res.message);
                }
            );
        },
        clickDownload() {
            let arr = this.multipleSelection
                .map((rs) => {
                    return rs.id;
                })
                .join(",");

            let data = {
                ids: arr.join(","),
            };
            fetch(url.download, data).then(
                (res) => {
                    if (res.status === 200) {}
                },
                (res) => {
                    this.$message.error(res.message);
                }
            );
        },

        getList() {
            let beginDate = "";
            let endDate = "";
            if (this.dealTime != "" && this.dealTime != null) {
                let dateBegin = new Date(this.dealTime[0]);
                let dateEnd = new Date(this.dealTime[1]);
                beginDate = `${dateBegin.getFullYear()}-${dateBegin.getMonth() +
                    1}-${dateBegin.getDate()}`;
                endDate = `${dateEnd.getFullYear()}-${dateEnd.getMonth() +
                    1}-${dateEnd.getDate()}`;
            }
            let data = {
                beginDate,
                endDate,
                mobile: this.mobile,
                acceivingStatus: this.acceivingStatus,
                writeOffStatus: this.writeOffStatus,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            };
            this.tLoading = true
            fetch(url.list, data).then((res) => {
                this.tLoading = false
                if (res.status === 200) {
                    this.tableData = res.data.list;
                    this.totalPage = res.data.totalRow;
                }
            }).catch(() => {
                this.tLoading = false
            });
        },

        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNo = val;
            this.getList();
        },
        handleDelSome() {
            let ids = this.multipleSelection
                .map((rs) => {
                    return rs.id;
                })
                .join(",");

            this.$confirm('是否确认删除已选中名单记录？删除后不可恢复', '删除名单', {
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fetchDel(ids)
                // this.$message({
                //     type: 'success',
                //     message: '删除成功!'
                // });
            }).catch(() => {});
        },
        fetchDel(id) {
            this.loadbtn = true
            fetch(url.del, {
                id: id
            }).then(res => {
                if (res.status === 200) {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.loadbtn = false
                    this.pClose(id)
                    this.multipleSelection = []
                    this.$refs.multipleTable.clearSelection();
                    this.getList()
                    this.getAmount()
                }
            }, () => {
                this.loadbtn = false
                this.pClose(id)
                this.multipleSelection = []
                this.$refs.multipleTable.clearSelection();
                this.getList()
            })
        },
        pClose(id) {
            // console.log('id', id, this.$refs[`popover-${id}`].doClose)
            if (this.$refs[`popover-${id}`]) {
                this.$refs[`popover-${id}`].doClose()
            }
        },
        onProgress(event, file, fileList) {
            console.log('event', event)
        },
        onError(err) {
            this.uLoading = false
            this.uploadDone = false
            // debugger
            this.$message.error(err.message);
        },
        fileChange(file) {

            if (this.uploadDone) {
                // 上传完成
                this.uploadDone = false
                return
            }
            console.log('fileChange = ', file)
            const _this = this
            // _this.tableData = []
            const fileName = file.name;
            console.log(fileName);
            const reader = new FileReader();
            this.receiveMoreList = []
            //提取excel中文件内容
            reader.readAsArrayBuffer(file.raw);
            reader.onload = function () {
                const buffer = reader.result;
                const bytes = new Uint8Array(buffer);
                const length = bytes.byteLength;
                let binary = "";
                for (let i = 0; i < length; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                const XLSX = require("xlsx"); //import xlsx from 'xlsx'
                console.log(XLSX);
                //转换二进制
                const wb = XLSX.read(binary, {
                    type: "binary",
                });
                debugger
                const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
                console.log(outdata);
                //这里for循环将excel表格数据转化成json数据
                let total = 0
                const distribution = _this.distribution
                let check = true
                if (_this.userInfo.allotType == 0) {
                    // 等额整额
                    outdata.forEach((i) => {
                        let obj = {
                            mobile: i['手机号'],
                            money: i['赠送金额'],
                            type: i['分配方式']
                        };

                        if (distribution != 2) {
                            // 
                            let type = obj.type
                            if (type == '整额') {
                                type = '0'
                            } else if (type == '等额') {
                                type = '1'
                            }
                            if (distribution + '' != type) {
                                check = false
                                return
                            }
                        }

                        _this.receiveMoreList.push(obj)
                        total += parseFloat(obj.money)
                    });
                } else {
                    // 闪付优惠券
                    outdata.forEach((i) => {
                        let obj = {
                            mobile: i['手机号']
                        };

                        _this.receiveMoreList.push(obj)
                    });
                }

                if (_this.userInfo.allotType == 0 && !check) {
                    _this.$message.error(`该账户只允许导入${distribution == 0 ? '整额':'等额'}的分配方式`);
                    return
                }

                _this.receiveTotal = total
                _this.dialogFormMoreVisible = true

            };
        },
        handleSaveImportMore() {
            this.uploadDone = true
            this.$refs.uploadFile.submit()
        },
        createHandleAvatarSuccess(fileName) {
            return (res, file) => {
                console.log('createHandleAvatarSuccess', res, file)
                this.uLoading = false
                if (res.status === 200) {
                    this.$message({
                        message: '上传成功',
                        type: "success",
                    });
                    this.getList()
                    this.getAmount()
                    // this.fileUrl = res.data.list[0].url;
                    // 上传导入接口
                    // this.handleImportExcel()
                    this.dialogFormMoreVisible = false
                } else {
                    if (res.message) {
                        this.$message.error(res.message);
                    } else {
                        this.$message.error('系统异常');
                    }
                }
            };
        },
        beforeAvatarUpload(file) {

            var index = file.name.lastIndexOf(".");
            //获取后缀
            var ext = file.name.substr(index + 1);
            let arr = ['xls', 'xlsx']
            let suc = arr.indexOf(ext.toLowerCase()) !== -1
            if (!suc) {
                this.$message.error("上传文件格式只能是xls、xsls!");
            } else {
                this.uLoading = true
            }

            return suc
        },
    },
};
</script>

<style>
#app {
    overflow: auto !important;
}

.el-form-item__label {
    color: #888;
    padding-right: 8px;
    white-space: normal !important;
}

.main {
    width: 1000px;
    padding: 20px;
    margin: 30px auto 30px;
    border: 1px solid #f7f7f7;
    background: #fcfcfc;
    box-shadow: rgb(230, 240, 240, 0.6) 5px 2px 40px 5px;
}

.d-sel {
    color: rgb(223, 217, 217);
}

.tit-con {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 18px;
}

.back-icon {
    width: 25px;
    height: 25px;
    margin: 0 10px 0 0
}

.select-count {
    color: #F18800;
    margin-top: 20px;
}
</style>

<style lang="scss" scoped>
.whiteList {
    .orderAudit-row {
        display: flex;
    }

    .tg {
        border-collapse: collapse;
        border-spacing: 0;
        width: 750px;
    }

    .tg td {
        font-size: 14px;
        padding: 8px 5px;
        border-style: solid;
        border-width: 1px;
        word-break: normal;
        border-color: #dfdcdc;

        &.np {
            padding: 0;
        }
    }

    .tg-sub {
        margin-top: -1px;
    }

    .tg .tg-cly1 {
        text-align: center;
        vertical-align: middle;
        font-size: 13px;
        font-weight: bold;
        // padding: 15px 10px;
        // &:empty::before {
        //   content: '1';
        // }
    }

    .tg .input {
        width: 100%;
        height: auto;
    }

    .tg .input input {
        height: auto;
        min-height: 30px;
        line-height: 30px;
    }

    .orderAudit-row-del {
        display: inline-block;
        color: $red_color;
    }

    .orderAudit-row-save {
        display: inline-block;
        color: $stategreen_color;
    }

    .info-message {
        display: flex;
        flex-wrap: wrap;
        // margin: -16px 4px 0;
        margin: 20px 0;
        color: #ff8400;
        border: 1px solid #ff8400;
        border-radius: 4px;
        background: #ffedda;
        font-size: 14px;
        padding: 6px 16px 4px;

        &>span {
            flex: none;
            margin-right: 42px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &:last-child {
                margin-right: 0;
            }
        }
    }
}
</style>
